import { Box, Button, Link, Paper, Typography } from '@mui/material';
import React, { useState } from 'react';

import { getCookie, setCookie } from '../../utils/cookie';

import { cookieConsentBannerStyles } from './styles/cookieConsentBannerStyles';

const CONSENT_COOKIE_NAME = 'cookie_consent';
const CONSENT_COOKIE_EXPIRY_DAYS = 365;

type ConsentChoice = 'accepted' | 'declined';

export const CookieConsentBanner: React.FC = () => {
  const [visible, setVisible] = useState<boolean>(() => !getCookie(CONSENT_COOKIE_NAME));

  const handleChoice = (choice: ConsentChoice) => {
    setCookie(CONSENT_COOKIE_NAME, choice, CONSENT_COOKIE_EXPIRY_DAYS);
    setVisible(false);
  };

  if (!visible) {
    return null;
  }

  return (
    <Paper
      elevation={4}
      role="dialog"
      aria-label="Cookie consent"
      data-testid="cookie-consent-banner"
      sx={cookieConsentBannerStyles.container}
    >
      <Box sx={cookieConsentBannerStyles.content}>
        {/* HA-403: placeholder copy — real, legal-reviewed text is a
            separate follow-up once legal/compliance signs off (see this
            ticket's plan for the open decisions this text doesn't answer).
            Do not treat this wording as final. */}
        <Typography variant="body2" sx={cookieConsentBannerStyles.text}>
          {/* HA-403: this banner is mounted as a sibling of <RouterProvider>
              (not inside it — see app.tsx), so it sits outside the React
              Router context entirely. A RouterLink there throws (useContext
              returns null); a plain anchor is the only correct option here,
              not a stylistic choice. */}
          We use cookies to keep you signed in and remember your preferences. See our{' '}
          <Link href="/Privacy" underline="hover">
            Privacy Policy
          </Link>{' '}
          for details.
        </Typography>
        <Box sx={cookieConsentBannerStyles.actions}>
          <Button
            variant="outlined"
            size="small"
            data-testid="cookie-consent-decline-btn"
            onClick={() => handleChoice('declined')}
          >
            Decline non-essential
          </Button>
          <Button
            variant="contained"
            size="small"
            data-testid="cookie-consent-accept-btn"
            onClick={() => handleChoice('accepted')}
          >
            Accept
          </Button>
        </Box>
      </Box>
    </Paper>
  );
};

export default CookieConsentBanner;
